import { isUniversalWindowsXP, isInOldApp4 } from '@utils/getEnv';
import * as Ids from '../ids';
import { getStorage, setStorage } from '../localStorage';
import request from '../axiosWrapper';

/** 灰度token枚举 新增时在入参grayToken要加上*/
enum GRAY_AB_TOKEN {
    /** 天平4期灰度 token */
    TIANPING_PHASE4 = '515367bc-2d9d-4c5b-9ecd-4e85555ccae8',
    /** 跑腿催取餐 token */
    URGE_TAKE_MEAL = '0fa03590-0dfe-4793-b056-8b4aaf11abd3',
    /** 配送动态起送价 token */
    DISTRIBUTION_PRICE = '052092d9-4445-4095-86d1-d4daeb2fcb3d',
    /** 自主售后(退款+定责改版合并)模块 token*/
    AFTER_SALE = '0a3c2246-4d1c-401f-b37f-d2e2dc95d906',
    /** 跑腿-拉黑骑手 */
    PT_DISPATCHER_BLACKLIST = 'aaeb14c0-43ba-476e-a087-7611e72db50a',
    /** 企客加小费 */
    QIKE_ADD_TIP = '33b7433329ea8d425cbcef94fa5ecc59',
    /** 出餐分二期 */
    MEAL_REPORT_PERCENT2 = 'd6515f52-dde5-42ba-a7a6-426311b9740a',
    /** 订单系统完单方案优化 */
    ORDER_AUTO_COMPLETE_TIPS = 'c6e24f7b-7414-4e36-b3ef-44d25f89e369',
    POI_ADDRESS_AGGREGATION = '19142869-bf94-48a9-a864-e431ee6d54a3',
    /** 配送服务健康度灰度 */
    DISTRIBUTION_HEALTH_DEGREE = '52c15706-2bdb-4dba-8444-9106fe14ac12',
    /** 餐损申诉理由结构化改造 */
    SHENSU_APPLY_FORMAT = '9cee2fad-18c4-49b7-8d58-bb3f2c05ec2e',
    /** 无人接单预期管理（同时具备灰度和判断门店类型的作用） */
    NO_RIDER_EXPECTATION_MANAGEMENT = '2b98127a-ba37-4b40-be92-717a5f6c7029',
    /** SLA赔付环节以及取消险入口优化 */
    SLA_PEIFU_OPTIMIZATION = '02b12b8b-b683-4419-8a5d-e570c1221ba4',
    /** 极速退优化 */
    FAST_REFUND = '3e3c8f77-01cc-407b-895f-5e96e2f09e76',
    /** [自配出餐上报](https://km.sankuai.com/collabpage/1695936739) */
    ZIPEI_MEAL_REPORT = 'c2c9ad55-85c0-4b52-b7fc-d50d7115e898',
    /** [食安赔付](https://km.sankuai.com/collabpage/1599139352) */
    FOOD_SAFETY_REFUND = 'eca87f67-1fde-47e5-8aa3-71b19c80b41c',
    /** 预定单修改ETA https://km.sankuai.com/collabpage/1860004752 */
    PRE_ORDER_EDIT_ETA = '1e5645c6-d97d-412f-86e8-89d33c89fb16',
    /** 出餐时间考核能力建设 https://km.sankuai.com/collabpage/1705285681 */
    PREMEAL_REPORT = 'e8e1f2bc-7b8d-2347-502d-1c2815377fb9',
    /** [预订单自动退款](https://km.sankuai.com/collabpage/1960870651) */
    PRE_ORDER_AUTO_REFUND = 'd6952d51-fb5e-46e1-951e-e8fbc98ca901',
    /** 场景化商家自主处理退款能力优化 */
    REFUND_OPTIMIZATION = 'refundOptimization',
    /** 订单卡片增加代理餐损申请入口 */
    AGENT_CANSUN_ENTRANCE = 'agent_cansun_entrance_show_gray_token',
    /** 大纠纷商责取消配送服务费宣导提示 https://km.sankuai.com/collabpage/2250892250#b-5ab2f63616244833aaf5e97837fc6907*/
    PRE_ORDER_CANCEL_SERVICE_FEE = 'cancelPerformanceFee',
    /** 出餐准时率权益建设 https://km.sankuai.com/collabpage/2092816744 */
    PREP_MEAL_NEW_STYLE = '8e72bbd1-d3d1-4ab6-9fe0-95fed39d4fa0',

    /* 分页改造相关 start */
    /** 待处理 - 进行中 */
    PAGINATION_UNPROCESSED_PROCESS = 'indexmod-orde-proc-essi-sceneprogres',
    /** 待处理 - 待发配送 */
    PAGINATION_UNPROCESSED_PREP_DELIVERY = 'indexmod-logi-tics-prep-sceneprogres',
    /** 待处理 - 配送异常 */
    PAGINATION_UNPROCESSED_DELIVERY_EXCEPTION = 'indexmod-logi-tics-erro-sceneprogres',
    /** 历史订单 - 全部/已取消/顾客已收餐 */
    PAGINATION_HISTORY_ALL_CANCEL_COMPLETE = 'indexmod-lall-over-canc-scenehistory',
    /** 历史订单 - 已处理退款 */
    PAGINATION_HISTORY_PROCESSED_REFUND = 'indexmod-over-hand-refu-scenehistory',
    /** 历史订单 - 待退款申诉 */
    PAGINATION_HISTORY_AFTER_SALE_CAN_APPEAL = 'indexmod-sale-afte-refu-scenehistory',
    /**大纠纷-商家售后考核*/
    MAJOR_DISPUTE_AUDIT_GRAY_KEY = 'major_dispute_audit_gray_key',

    /* 分页改造相关 end */

    /** 极速退灰度 */
    EXTREME_RETROGRESSION = 'instant_refund_node_update_gray_config',
    /** 跑腿B内扣款逻辑  */
    PAOTUI_PAYMENT = 'paotui_b_payment_optimize_gray_config',
    /** 300 账号门店增加待出餐 tab灰度 */
    MEAL_TAB_GRAW = 'plus_300_add_wait_meal_tab_gray',

    /** 餐饮新形态 */
    UNIFIED_ORDER = 'catering-new-model-scene-gray-token',
    /** 拼好饭卡片灰度 */
    PHF_ORDER_CARD = 'phf-integration-scene-gray-token',
    /** 新卡餐上报灰度 */
    KACAN_GRAY_KEY = '8a7b9c3e-f2d1-4e6g-h5i8-j7k6l4m3n2o1',
}

/** localStorage 缓存 key */
const GRAY_INFO_CACHE_KEY = 'AB_GRAY_CACHE';
const poiKey = `${Ids.getAcctId()}#${Ids.getWmPoiId()}`;

/** 灰度配置项 */
type GRAY_CONFIG = {
    /** 灰度业务Token和入参一致 */
    grayToken: string;
    /** 命中的灰度策略 */
    hintStrategy: string;
    /** 业务标识说明 */
    businessName: string;
    /** 是否命中灰度 */
    inGray: boolean;
    /** 白名单列表 */
    idsInGray?: Array<number | string>;
};

/** 前端缓存的灰度信息 */
let GRAY_INFO_CACHE: {
    /** 账号ID和门店ID组成的ID，用于判断本地localStorage中的缓存信息是否有效 */
    poiKey: string;
    data: GRAY_CONFIG[];
} = {
    poiKey,
    data: [],
};
export enum hintStrategy {
    /** 自配 */
    SELF = 'self',
    /** 美配 */
    COMMON = 'common',
}
try {
    // 从localStorage加载缓存
    const localCache = JSON.parse(getStorage(GRAY_INFO_CACHE_KEY) || '{}');
    if (localCache && localCache.poiKey === poiKey && Array.isArray(localCache.data)) {
        GRAY_INFO_CACHE = localCache;
    }
} catch (e) {
    // 静默
}

/**
 * 请求灰度配置
 */
const requestGrayInfo = () => {
    return request
        .postAsFormSubmit<GRAY_CONFIG[]>('/gw/api/common/gray/ab', {
            grayToken: [
                GRAY_AB_TOKEN.TIANPING_PHASE4,
                GRAY_AB_TOKEN.URGE_TAKE_MEAL,
                GRAY_AB_TOKEN.DISTRIBUTION_PRICE,
                GRAY_AB_TOKEN.AFTER_SALE,
                GRAY_AB_TOKEN.PT_DISPATCHER_BLACKLIST,
                GRAY_AB_TOKEN.QIKE_ADD_TIP,
                GRAY_AB_TOKEN.MEAL_REPORT_PERCENT2,
                GRAY_AB_TOKEN.ORDER_AUTO_COMPLETE_TIPS,
                GRAY_AB_TOKEN.POI_ADDRESS_AGGREGATION,
                GRAY_AB_TOKEN.DISTRIBUTION_HEALTH_DEGREE,
                GRAY_AB_TOKEN.SHENSU_APPLY_FORMAT,
                GRAY_AB_TOKEN.NO_RIDER_EXPECTATION_MANAGEMENT,
                GRAY_AB_TOKEN.SLA_PEIFU_OPTIMIZATION,
                GRAY_AB_TOKEN.FAST_REFUND,
                GRAY_AB_TOKEN.ZIPEI_MEAL_REPORT,
                GRAY_AB_TOKEN.FOOD_SAFETY_REFUND,
                GRAY_AB_TOKEN.PRE_ORDER_EDIT_ETA,
                GRAY_AB_TOKEN.PREMEAL_REPORT,
                GRAY_AB_TOKEN.PRE_ORDER_AUTO_REFUND,
                GRAY_AB_TOKEN.REFUND_OPTIMIZATION,
                GRAY_AB_TOKEN.AGENT_CANSUN_ENTRANCE,
                GRAY_AB_TOKEN.PREP_MEAL_NEW_STYLE,
                GRAY_AB_TOKEN.PAGINATION_UNPROCESSED_PROCESS,
                GRAY_AB_TOKEN.PAGINATION_UNPROCESSED_PREP_DELIVERY,
                GRAY_AB_TOKEN.PAGINATION_UNPROCESSED_DELIVERY_EXCEPTION,
                GRAY_AB_TOKEN.PAGINATION_HISTORY_ALL_CANCEL_COMPLETE,
                GRAY_AB_TOKEN.PAGINATION_HISTORY_PROCESSED_REFUND,
                GRAY_AB_TOKEN.PAGINATION_HISTORY_AFTER_SALE_CAN_APPEAL,
                GRAY_AB_TOKEN.MAJOR_DISPUTE_AUDIT_GRAY_KEY,
                GRAY_AB_TOKEN.PRE_ORDER_CANCEL_SERVICE_FEE,
                GRAY_AB_TOKEN.EXTREME_RETROGRESSION,
                GRAY_AB_TOKEN.PAOTUI_PAYMENT,
                GRAY_AB_TOKEN.MEAL_TAB_GRAW,
                GRAY_AB_TOKEN.UNIFIED_ORDER,
                GRAY_AB_TOKEN.PHF_ORDER_CARD,
                GRAY_AB_TOKEN.KACAN_GRAY_KEY,
            ].join(','),
            grayStrategyType: 1,
            appType: 3,
            acctId: Ids.getAcctId(),
            wmPoiId: Ids.getWmPoiId(),
            token: Ids.getToken(),
        })
        .then(res => {
            GRAY_INFO_CACHE = {
                poiKey,
                data: res || [],
            };
            // 将最新数据写入 localStorage
            setStorage(GRAY_INFO_CACHE_KEY, JSON.stringify(GRAY_INFO_CACHE));
        });
};

/**
 * 根据灰度 token 判断是否处于灰度状态
 */

function getGrayStateByToken(token: string): boolean;
function getGrayStateByToken(token: string, filterVal: string): boolean;
function getGrayStateByToken(token: string, filterVal?: string) {
    /** 餐饮新形态在xp和老壳子，默认不灰度 */
    if (
        (token === GRAY_AB_TOKEN.UNIFIED_ORDER || token === GRAY_AB_TOKEN.PHF_ORDER_CARD) &&
        (isUniversalWindowsXP || isInOldApp4)
    ) {
        return false;
    }
    const matchedConfig = GRAY_INFO_CACHE.data.filter(function(config) {
        return config.grayToken === token;
    })[0];
    if (matchedConfig) {
        return (
            matchedConfig.inGray ||
            (filterVal !== undefined &&
                Array.isArray(matchedConfig.idsInGray) &&
                matchedConfig.idsInGray.join(',').indexOf(filterVal) !== -1)
        );
    } else {
        // 未查询到匹配的灰度 token, 默认未命中灰度
        return false;
    }
}
/** 判断当前灰度命中 策略*/
function getGrayStateByhintStrategy(token: string): string {
    const matchedConfig = GRAY_INFO_CACHE.data.filter(function(config) {
        return config.grayToken === token;
    })[0];
    if (matchedConfig) {
        return matchedConfig.hintStrategy;
    } else {
        // 未查询到匹配的灰度 token, 默认未命中灰度
        return '';
    }
}

/** 降级
 * 按位降级，例如接口下发27，二进制11011。需求x降级位为2，27的第三位为0，表示需要降级
 */
/** token和降级位的映射关系 */
const DowngradeNumByToken = {
    [GRAY_AB_TOKEN.FOOD_SAFETY_REFUND]: 9,
    [GRAY_AB_TOKEN.ZIPEI_MEAL_REPORT]: 10,
    [GRAY_AB_TOKEN.FAST_REFUND]: 11,
    [GRAY_AB_TOKEN.PREMEAL_REPORT]: 13,
    [GRAY_AB_TOKEN.UNIFIED_ORDER]: 15,
    [GRAY_AB_TOKEN.PHF_ORDER_CARD]: 16,
} as Record<string, number>;
/** 降级 */
function getDowngradeByBit(downgradeNum: number, token: string): boolean {
    if (DowngradeNumByToken[token] !== undefined) {
        // eslint-disable-next-line no-bitwise
        return ((downgradeNum >> DowngradeNumByToken[token]) & 1) === 0;
    }
    return false;
}
export {
    requestGrayInfo,
    getGrayStateByToken,
    GRAY_AB_TOKEN,
    getDowngradeByBit,
    getGrayStateByhintStrategy,
};
